import { makeStyles } from "@material-ui/styles";

const configurationStyles = makeStyles((theme) => ({
	section: {
		padding: ({ preview }) => !preview && theme.spacing(0, 4, 4, 4),
		width: "100%"
	},
	sectionLabel: {
		textTransform: "capitalize",
		padding: theme.spacing(2, 0)
	},
	sectionHeader: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		flexWrap: "wrap"
	},
	sectionActions: {
		display: "flex",
		flexWrap: "wrap",
		gap: theme.spacing(1)
	},
	sectionRow: {
		margin: theme.spacing(0)
	},
	sectionDivider: {
		marginBottom: theme.spacing(4)
	},
	actionContainer: {
		width: "100%",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		overflowX: "auto",
		gap: "5px"
	},
	primaryActionContainer: {
		display: "flex",
		alignItems: "center",
		gap: "5px",
		// Keeps Save/Cancel pinned right when the secondary actions
		// (Restore defaults / ruleset) are hidden, e.g. mid-game.
		marginLeft: "auto"
	},
	autoComplete: {
		"& .MuiAutocomplete-inputRoot": { paddingRight: "15px !important" }
	},
	// Fieldset drawn like a MUI v4 outlined input (border color/radius of
	// OutlinedInput's NotchedOutline, same 56px height as the sibling
	// fields) so boolean switches read as one form control among the rest.
	switchField: {
		boxSizing: "border-box",
		position: "relative",
		width: "100%",
		height: 56,
		margin: 0,
		padding: theme.spacing(0, 1.75),
		border: `1px solid ${
			theme.palette.type === "dark"
				? "rgba(255, 255, 255, 0.23)"
				: "rgba(0, 0, 0, 0.23)"
		}`,
		borderRadius: theme.shape.borderRadius
	},
	// Legend sits in the border notch like a shrunk outlined-input label:
	// caption size, secondary color, ~8px from the border start (padding-left
	// is 14px, so pull back 6px). The 11px line box matches MUI's
	// NotchedOutline legend so it doesn't push the content down.
	switchFieldLabel: {
		padding: theme.spacing(0, 0.5),
		marginLeft: -6,
		color: theme.palette.text.secondary,
		fontSize: theme.typography.caption.fontSize,
		height: 11,
		lineHeight: "11px"
	},
	// Center the switch in the 56px box independently of the legend's flow
	// (the legend straddles the top border and would offset static content).
	switchFieldControl: {
		position: "absolute",
		top: "50%",
		left: theme.spacing(1),
		transform: "translateY(-50%)"
	},
	iconAdornment: {
		width: "25px",
		height: "25px"
	}
}));

export default configurationStyles;
